import html from "./SurveyModal.html"
import "../../../modal.css"
import "./SurveyModal.css"
import "../../MyDataHelps/ParticipantDeviceInfoService.js"
import "../SurveyStep.js"
import appActionHandler from "../../../helpers/appActionHandler"

var module = angular.module("ResearchKitApplicationModule");

module.component('surveyModal', {
	template: html,
	bindings: {
		surveyManager: '<',
		isConsent: '<',
		platforms: '<'
	},
	controller: 'surveyModalController',
	controllerAs: 'vm'
});

module.controller("surveyModalController", ["$element", "$scope", "$document", "$window", "$timeout", "participantDeviceInfoService",
	function ($element, $scope, $document, $window, $timeout, participantDeviceInfoService) {
		var vm = this;
		vm.loading = true;

		vm.browser = participantDeviceInfoService.getBrowser();

		vm.showLoading = function () {
			return vm.loading || (vm.surveyManager && vm.surveyManager.finishing);
		}

		vm.$onChanges = function (changesObj) {
			if (changesObj.surveyManager) {
				if (changesObj.surveyManager.currentValue) {
					$("body").addClass("no-scroll");
					vm.loading = false;
				}
				else if (changesObj.surveyManager.previousValue) {
					vm.loading = true;
				}
			}
			if (changesObj.platforms && changesObj.platforms.currentValue) {
				vm.loading = false;
			}
		};

		vm.$onDestroy = function () {
			$("body").removeClass("no-scroll");

			$window.clearInterval(vm.fitOverlayInterval);
			$window.clearInterval(vm.fitNavValidationModalInterval);

			$document.off("keydown", handleKeydown);

			$element.remove();
		};

		function findVisibleFocusable(parent) {
			return parent
				.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]')
				.filter(":visible");
		}

		function handleKeydown(event) {
			var focusableElements = findVisibleFocusable($element);

			switch (event.keyCode) {
				case $.ui.keyCode.TAB:
					//Focus trap e.g. https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
					if (elementToFocusOnNextTab) {
						setTimeout(function () {
							if (elementToFocusOnNextTab) {
								elementToFocusOnNextTab.focus();
								elementToFocusOnNextTab = null;
							}
						});
						break;
					}

					if (event.shiftKey) {
						if ($document[0].activeElement === focusableElements.get(0)) {
							event.preventDefault();
							focusableElements[focusableElements.length - 1].focus();
						}
					} else {
						if ($document[0].activeElement === focusableElements.get(focusableElements.length - 1)) {
							event.preventDefault();
							focusableElements[0].focus();
						}
					}
					break;
				case $.ui.keyCode.ESCAPE:
					$scope.$apply(function () {
						vm.finishSurvey();
					});
					break;
				default:
					break;
			}
		}

		var elementToFocusOnNextTab;

		vm.$postLink = function () {
			$element.appendTo("body");

			function fitOverlay() {
				var overlayHeight = $element.find(".current-survey").height() + 80;
				var windowHeight = $($window).height();
				if (windowHeight > overlayHeight) {
					overlayHeight = windowHeight;
				}
				$element.find(".current-survey-overlay").height(overlayHeight);
			}
			vm.fitOverlayInterval = $window.setInterval(fitOverlay, 500);

			var modal = $element.find(".rk-modal");

			$scope.$on("setStep", function () {
				$timeout(function () {
					calculateShowScrollMarker();
					modal.scrollTop(0);
					elementToFocusOnNextTab = findVisibleFocusable(modal.find(".current-step")).first();
				}, 100);
			});

			$scope.$on("refocus", function () {
				$timeout(function () {
					findVisibleFocusable(modal.find(".current-step")).first().focus();
					setTimeout(function () {
						modal.scrollTop(0);
					}, 0);
				});
			});

			function calculateShowScrollMarker() {
				if (vm.surveyManager) {
					vm.surveyManager.currentStepManager.showScrollMarker = modal.scrollTop() + modal.outerHeight() < modal[0].scrollHeight;
				}
			}

			var throttledOnScroll = _.throttle(function () {
				$scope.$apply(calculateShowScrollMarker);
			}, 150);

			modal.on("scroll", throttledOnScroll);

			modal.on("focusin", function () {
				elementToFocusOnNextTab = null;
			});

			var screenChangeEvents = "webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange";
			$document.on(screenChangeEvents, function () {
				var fullScreenElement = $document[0].fullscreenElement || $document[0].mozFullScreenElement || $document[0].webkitFullscreenElement || $document[0].msFullscreenElement;
				// Note: iframe check is necessary for full-screening video in iframe
				if (fullScreenElement && fullScreenElement.tagName === "IFRAME") {
					return;
				}
				if (fullScreenElement) {
					$element.appendTo($(fullScreenElement));
				} else {
					$element.appendTo($("body"));
				}
			});

			$document.on("keydown", handleKeydown);
		};

		vm.getCssClass = function () {
			if (!vm.surveyManager || vm.surveyManager.getMode() !== "Design") {
				return "survey-mode";
			}
			return "";
		};

		vm.finishSurvey = function () {
			$scope.$emit('surveyFinished');
		};

		$scope.$on("cancelSurvey", function () {
			if (vm.surveyManager) vm.surveyManager.close();
			else vm.finishSurvey();
		});

		$scope.$on("androidBackButtonPressed", function () {
			$scope.$apply(function () {
				if (!vm.surveyManager?.managedStepIdentifiers || vm.surveyManager.managedStepIdentifiers.length <= 1) {
					//if at the beginning of the survey, close it
					vm.loading = true;
					vm.surveyManager = null;
					appActionHandler.surveyFinished("Closed", null);
				}
				else if (vm.surveyManager.currentStepManager) {
					//rely on the step manager back(); because steps may embed specific behavior into the back button
					//e.g. consent steps have "sub-steps"
					vm.surveyManager.currentStepManager.back();
				}
			});
		});
	}]);
